export default "__VITE_ASSET__52ac266b__"